(function () {
    'use strict';

    angular.module('PWAPoCApp')
        .factory('httpDebugInterceptor', httpDebugInterceptor)
        .config(['$httpProvider', function($httpProvider) {
            $httpProvider.interceptors.push('httpDebugInterceptor');
        }]);
    httpDebugInterceptor.$inject = ['$q', '$rootScope'];

    function httpDebugInterceptor($q, $rootScope) {

        if (!$rootScope.debugNetwork) {
            $rootScope.debugNetwork = [];
        }

        return {
            request: function (config) {
                config.debugStart = performance.now();
                return config;
            },

            response: function (response) {

                $rootScope.debugNetwork.unshift({
                    time: new Date(),
                    method: response.config.method,
                    url: response.config.url,
                    status: response.status,
                    duration: Math.round(performance.now() - response.config.debugStart),
                    requestHeaders: response.config.headers,
                    responseHeaders: response.headers(),
                    data: response.data
                });

                return response;
            },

            responseError: function (rejection) {

                $rootScope.debugNetwork.unshift({
                    time: new Date(),
                    method: rejection.config?.method,
                    url: rejection.config?.url,
                    status: rejection.status,
                    duration: Math.round(performance.now() - (rejection.config?.debugStart || 0)),
                    error: rejection.data
                });

                return $q.reject(rejection);
            }
        };
    }
})();
